module.exports = __webpack_public_path__ + "static/media/13.34cf192f.jpg";